<template>
<div class="container">
  <div class="screen screenLoader" v-if="isFileUploadInProgress">
      <div class="loader">
      </div>
  </div>
  <div class="screen" v-if="confirmationPoupFlag">
    <div class="drpPopup">
      <div class="decisionTitle">
      <div class="confirmationTxt">{{ $t("message.upload_popup.no_file_txt") }}</div>
      </div>
      <div class="drpPopupBtnHolder">
         <span @click="closeConfirmationPopup()" class="leftBtnPopup">{{ $t("message.upload_popup.no_upload_file") }}</span>
         <span @click="moveToMetadataPage()"    class="rightBtnPopup">{{ $t("message.upload_popup.yes_skip_step") }}</span>
      </div>
    </div>
  </div>
  <div class="screen" v-if="uploadFileToServerConfirmationPoupFlag">
    <div class="drpPopup">
      <div class="decisionTitle">
      <div class="confirmationTxt">{{ $t("message.upload_popup.ensure_upload_txt") }}</div>
      </div>
      <div class="drpPopupBtnHolder">
        <span @click="closeUploadConfirmationPopup()"  class="leftBtnPopup">{{ $t("message.upload_popup.no_review_upload") }}</span>
        <span @click="uploadFiles()" class="rightBtnPopup">{{ $t("message.upload_popup.yes_finish_upload") }}</span>
      </div>
    </div>
  </div>
  <div class="screen" v-if="discardFilesConfirmationPoupFlag">
    <div class="drpPopup">
      <div class="decisionTitle">
      <div class="confirmationTxt">{{ $t("message.upload_popup.discard_uploadfile_txt") }}</div>
      </div>
      <div class="drpPopupBtnHolder">
        <span @click="closeDiscardFilePopup()" class="leftBtnPopup">{{ $t("message.upload_popup.no_stay_page") }}</span>
        <span  @click="moveToLandingPage()" class="rightBtnPopup">{{ $t("message.upload_popup.yes_discard_file") }}</span>
      </div>
    </div>
  </div>
  <div class="col-lg-12 tp15">
    <span class="backText" v-bind:class="[{'opacity5': isFileUploadInProgress}]" @click="backButtonClick()"> <i class="fa fa-angle-left"></i> {{ $t("message.front_page.back_btn") }}</span>
    <span class="middleHolder">
      <span class="completedTask"></span>
      <span class="connectingLine"></span>
      <span class="pendingTask"></span>
    </span>
    <div class="centerDiv">
      <span class="uploadTxt">{{ $t("message.upload_page.upload_txt") }}</span>
      <span class="metadataTxt">{{ $t("message.upload_page.metadata_txt") }}</span>
    </div>
  </div>
  <div class="col-lg-12 tp15">
    <span class="filesAndFoldersTxt">{{ $t("message.upload_page.upload_file") }}</span>
    <span class="fltRight"><button class="completeTask nextPosition" @click="nextButtonClick()" v-bind:class="[{'opacity5': isFileUploadInProgress}]" >{{ $t("message.upload_page.next_btn") }}</button></span>
    <!--- <span @click="moveToMetadataPage()" class="fltRight skipTxt">Skip this step</span> -->
  </div>

  <div class="col-lg-12 tp15">
    <span>{{ $t("message.upload_page.filename_note") }}</span>
  </div>

  <div class="col-lg-12 drpAndFilesContainer">
    <div class="drpHolder" v-bind:class="[{'moveLeft': isFilesUploaded}]">
      <div id="drpContainer" class="dropzone">
        
      </div>
    </div>  
    <div id="statusContainer" v-show.visible="isFilesUploaded">
      <div class="uploadText">{{ $t("message.upload_page.uploaded_file") }}</div>
      <div class="dropzone-previews" id="previewContainer"></div>
    </div>
  </div>
</div>
</template>

<script>
  import Dropzone from 'dropzone'

  Dropzone.autoDiscover = false

  export default {
    props: ['rejectReasonPopupFlag'],
    data () {
      return {
        isFilesUploaded: false,
        isFileUploadInProgress: false,
        confirmationPoupFlag: false,
        uploadFileToServerConfirmationPoupFlag: false,
        discardFilesConfirmationPoupFlag: false
      }
    },
    created () {
      if (this.$store.getters.allFiles.dropzoneConfig.delflag === 1) {
        this.$router.push({name: 'Frozen'})
      }
      console.log('New files' + this.$store.getters.getUserDetails)
    },
    mounted () {
      const vm = this

      let options = {
        // The URL will be changed for each new file being processing
        url: '/',

        // Since we're going to do a `PUT` upload to S3 directly
        method: 'put',

        // Hijack the xhr.send since Dropzone always upload file by using formData
        // ref: https://github.com/danialfarid/ng-file-upload/issues/743
        sending (file, xhr) {
          var _send = xhr.send
          xhr.send = function () {
            _send.call(xhr, file)
          }
        },

        // Upload one file at a time since we're using the S3 pre-signed URL scenario
        parallelUploads: 1,
        timeout: 600000, // 10 minutes
        uploadMultiple: true,
        addRemoveLinks: true,
        dictCancelUpload: '<span class="drpAllImgSvg crossImg"></span>',
        dictRemoveFile: '<span class="drpAllImgSvg crossImg"></span><span class="completedtxt">Completed</span><span class="failedtxt">Upload failed</span>',
        // Content-Type should be included, otherwise you'll get a signature
        // mismatch error from S3. We're going to update this for each file.
        headers: {'x-amz-server-side-encryption': 'AES256'},

        // Customize the wording
        dictDefaultMessage: '<div><div class="msgDrop">' + this.$i18n.t('message.upload_page.drop_file_txt') + '</div><div class="uploadImg"></div><div class="msgChoose">' + this.$i18n.t('message.upload_page.choose_file_txt') + '</div></div>',
        // We're going to process each file manually (see `accept` below)
        autoProcessQueue: false,
        createImageThumbnails: false

      }

      // Instantiate Dropzone
      console.log(this.$el)
      console.log(options)
      options.previewsContainer = '#previewContainer'
      this.dropzone = new Dropzone(document.getElementById('drpContainer'), options)

      // Set signed upload URL for each file
      vm.dropzone.on('processing', function (file) {
        vm.dropzone.options.url = file.uploadURL
      })

      vm.dropzone.on('addedfile', function (file) {
        const newName = file.name.replace(/[[\]`~!@#$%^&*()_|+\-=?;:'",<>/{}]/g, '_')
        console.log('Replaced File name----------')
        console.log(newName)
        file.newName = newName
        file.previewElement.querySelector('.dz-filename span').textContent = newName
        vm.isFilesUploaded = true
      })

      vm.dropzone.on('queuecomplete', function (file) {
        console.log(vm.dropzone.getQueuedFiles().length)
        if (vm.dropzone.getUploadingFiles().length === 0 && vm.dropzone.getQueuedFiles().length === 0) {
          vm.isFileUploadInProgress = false
          console.log('queue over')
          vm.$router.push({name: 'Metadata'})
          // this.$store.commit(FILES_UPLOAD_SUCCESS, {})
        }
      }
      // .bind(this)
      )
    },
    methods: {
      backButtonClick () {
        if (this.dropzone.files.length > 0) {
          this.discardFilesConfirmationPoupFlag = true
        } else {
          this.$router.push({name: 'Files'})
          var langDropdown = document.querySelector('#langDropdown')
          if (langDropdown !== undefined && langDropdown !== null) {
            langDropdown.querySelector('select').disabled = false
          }
        }
      },
      moveToLandingPage () {
        this.$router.push({name: 'Files'})
        var langDropdown = document.querySelector('#langDropdown')
        if (langDropdown !== undefined && langDropdown !== null) {
          langDropdown.querySelector('select').disabled = false
        }
      },
      closeDiscardFilePopup () {
        this.discardFilesConfirmationPoupFlag = false
      },
      uploadFiles: function (e) {
        this.uploadFileToServerConfirmationPoupFlag = false
        this.isFileUploadInProgress = true
        var payload = {}
        payload.sessionid = this.$store.getters.getUserDetails
        payload.files = []
        var filesToUpload = this.dropzone.files.filter(this.getQueuedFiles)
        if (filesToUpload.length > 0) {
          for (var i = 0; i < filesToUpload.length; i++) {
            // payload.files.push(filesToUpload[i].name)
            payload.files.push(filesToUpload[i].newName || filesToUpload[i].name)
          }
          this.$store.dispatch('signedUrlForUpload', payload).then(function () {
            var signedUrls = this.$store.getters.signedUrlForUpload
            for (var j = 0; j < filesToUpload.length; j++) {
              this.processFiles(j, signedUrls[j], filesToUpload)
            }
          }.bind(this))
        } else {
          this.isFileUploadInProgress = false
        }
      },
      getQueuedFiles: function (files) {
        return files.status === 'queued'
      },
      processFiles: function (index, url, filesToUpload) {
        setTimeout(function () {
          filesToUpload[index].uploadURL = url
          this.dropzone.processFile(filesToUpload[index])
        }.bind(this))
      },
      nextButtonClick () {
        if (!this.isFileUploadInProgress) {
          if (this.dropzone.files.length === 0) {
            this.confirmationPoupFlag = true
          } else {
            this.uploadFileToServerConfirmationPoupFlag = true
          }
        }
      },
      closeConfirmationPopup () {
        this.confirmationPoupFlag = false
      },
      closeUploadConfirmationPopup () {
        this.uploadFileToServerConfirmationPoupFlag = false
      },
      moveToMetadataPage () {
        this.$router.push({name: 'Metadata'})
      }
    }
  }
</script>
<style>
.dropzone,
.dropzone *,
.dropzone-previews,
.dropzone-previews * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.dropzone {
  position: relative;
  border: 1px dashed rgba(0,0,0,0.08);
  background: rgba(0,0,0,0.02);
  padding: 1em;
  cursor: pointer;
}
.dropzone.dz-clickable {
  cursor: pointer;
}
.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message span {
  cursor: pointer;
}
.dropzone.dz-clickable * {
  cursor: pointer;
}
.dropzone .dz-message {
  opacity: 1;
  -ms-filter: none;
  filter: none;
}
.dropzone.dz-drag-hover {
  border-color: rgba(0,0,0,0.15);
  background: rgba(0,0,0,0.04);
}
.dropzone.dz-started .dz-message {
  display: none;
}
.dropzone .dz-preview,
.dropzone-previews .dz-preview {
  background: rgba(255,255,255,0.8);
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 100%;
}
.dropzone .dz-preview.dz-file-preview [data-dz-thumbnail],
.dropzone-previews .dz-preview.dz-file-preview [data-dz-thumbnail] {
  display: none;
}
.dropzone .dz-preview .dz-details,
.dropzone-previews .dz-preview .dz-details {
  width: 90%;
  height: 31px;
  background: transparent;
}
.dropzone .dz-preview .dz-details .dz-filename,
.dropzone-previews .dz-preview .dz-details .dz-filename {
  overflow: hidden;
  height: 100%;
}
.dropzone .dz-preview .dz-details img,
.dropzone-previews .dz-preview .dz-details img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
}
.dropzone .dz-preview .dz-details .dz-size,
.dropzone-previews .dz-preview .dz-details .dz-size {
  position: absolute;
  bottom: -28px;
  left: 3px;
  height: 28px;
  line-height: 28px;
}
.dropzone .dz-preview.dz-error .dz-error-mark,
.dropzone-previews .dz-preview.dz-error .dz-error-mark {
  display: block;
}
.dropzone .dz-preview.dz-success .dz-success-mark,
.dropzone-previews .dz-preview.dz-success .dz-success-mark {
  display: block;
}
.dropzone .dz-preview:hover .dz-details img,
.dropzone-previews .dz-preview:hover .dz-details img {
  display: none;
}
.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark {
  display: none;
  position: absolute;
  width: 40px;
  height: 40px;
  font-size: 30px;
  text-align: center;
  right: -10px;
  top: -10px;
}
.dropzone .dz-preview .dz-success-mark,
.dropzone-previews .dz-preview .dz-success-mark {
  color: #8cc657;
}
.dropzone .dz-preview .dz-error-mark,
.dropzone-previews .dz-preview .dz-error-mark {
  color: #ee162d;
}
.dropzone .dz-preview .dz-progress,
.dropzone-previews .dz-preview .dz-progress {
  position: absolute;
  top: 100px;
  left: 0px;
  margin-top: -60px;
  right: 0px;
  height: 3px;
  background: #d7d7d7;
  display: none;
}
.dropzone .dz-preview .dz-progress .dz-upload,
.dropzone-previews .dz-preview .dz-progress .dz-upload {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0%;
  background-color: #337AB7;
}
.dropzone .dz-preview.dz-processing .dz-progress,
.dropzone-previews .dz-preview.dz-processing .dz-progress {
  display: block;
}
.dropzone .dz-preview .dz-error-message,
.dropzone-previews .dz-preview .dz-error-message {
  display: none;
  position: absolute;
  top: -5px;
  left: -20px;
  background: rgba(245,245,245,0.8);
  padding: 8px 10px;
  color: #800;
  min-width: 140px;
  max-width: 500px;
  z-index: 500;
}
.dropzone .dz-preview:hover.dz-error .dz-error-message,
.dropzone-previews .dz-preview:hover.dz-error .dz-error-message {
  display: block;
}
.dropzone {
  border: 1px dashed rgba(0,0,0,0.03);
  min-height: 300px;
  max-height: 300px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  background: rgba(0,0,0,0.03);
  padding: 23px;
}
.dropzone .dz-default.dz-message {
  opacity: 1;
  -ms-filter: none;
  filter: none;
  -webkit-transition: opacity 0.3s ease-in-out;
  -moz-transition: opacity 0.3s ease-in-out;
  -o-transition: opacity 0.3s ease-in-out;
  -ms-transition: opacity 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  top: 35%;
  left: 35%;
}
.drpAndFilesContainer{
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
  margin-top: 30px;
  height: 420px;
  overflow:hidden;
    
} 

.drpHolder{
  height:420px;
  width: 60%;
  margin: 0px auto;
  cursor:pointer;

}

.drpHolder.moveLeft{
    width: 50%;
    padding-right: 25px;
    margin: auto;
    display: inline-block;
    transition: 1.5s;
}

#drpContainer{
    top: 13%;
    margin: 0px auto;
    background: rgba(235,235,235,0.30);
    border: 1px dashed #B2B2B2;
    border-radius: 3px;
    cursor:pointer;
    position: relative;
}
.dz-message{
  width: 100%;
    text-align: center;
    margin: 0%;
    margin-top: 9% !important;
    left: auto !important;
    position: relative !important;
}
.msgDrop{
  font-family: robotoRegular;
  font-size: 22px;
  color: #212121;
  text-align: center;
  cursor:pointer;
}
.msgChoose{
  font-family: robotoRegular;
  font-size: 16px;
  color: #212121;
  text-align: center;
  cursor:pointer;
}
.msgChoose a{
  font-family: robotoRegular;
  font-size: 16px;
  cursor: pointer;  
  text-align: center;
  line-height: 21px;
}
#drpContainer.moveleft{
  margin: 0px 20px;

}
#statusContainer{
  width: 46%;
  margin-top: 40px;
  position: absolute;
    display: inline-block;

}
.uploadText{
  font-family: robotoRegular;
  font-size: 16px;
  color: #212121
}

.dz-remove{
    margin-top: -31px;
    position: absolute;
    display: inline-block;
    left: 96%;
}


.dz-complete .dz-remove, .dz-error .dz-remove {
  position: initial;
}

.dz-size{
  display: block !important;
  top: 1px;
  left: -8px;
  background-position: -8px -211px;
  width: 23px;
  background-image: url(/static/images/drpIcons.svg);
}

.uploadImg{
  background-position: -294px -160px;
  background-image: url(/static/images/drpIcons.svg);
  width: 96px;
  height: 88px;
  margin: 0px auto;
  cursor:pointer;

}
.dz-size span{
  display:none;
}
.dz-filename{
  left: 30px;
  position: absolute;
  font-family: robotoRegular;
  font-size: 13px;
  color: #000000;
}

.dz-success-mark , .dz-error-mark,.dz-complete .dz-progress{
  display:none !important;
}

#previewContainer{
  height: 270px;
  margin-top: 14px;
  overflow-y: auto;
  overflow-x: hidden;
}

.opacity5{
  opacity: 0.5;
  cursor: default;
}

.dz-complete dz-remove{
  pointer-events: none;
}

.dz-remove .crossImg{
  right: -14px;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// DropzoneFormNew.vue?4bba3847